export const ZONE_DEFAULT_VALUES = {
  ZoneCode: '',
  Description: '',
  IsDefault: false,
  IsActive: false,
  IsDeleted: false,
  Flags: false,
  Category: '',
  Code2: '',
  Code3: '',
  Code4: '',
  Description2: '',
  Description3: '',
  Description4: '',
  AgencyID: '',
  Zone1: '',
  Zone2: '',
  Zone3: '',
  Zone4: '',
  Zone5: '',
};

export const ZONE_TEXT_FIELDS = [
  { name: 'ZoneCode', label: 'Zone Code' },
  { name: 'Zone1', label: 'Zone 1' },
  { name: 'Zone2', label: 'Zone 2' },
  { name: 'Zone3', label: 'Zone 3' },
  { name: 'Zone4', label: 'Zone 4' },
  { name: 'Zone5', label: 'Zone 5' },
  { name: 'Description', label: 'Description' },
  { name: 'Code2', label: 'Code 2/Description 2' },
  { name: 'Description2', label: 'Description 2' },
  { name: 'Code3', label: 'Code 3/Description 3' },
  { name: 'Description3', label: 'Description 3' },
  { name: 'Code4', label: 'Code 4/Description 4' },
  { name: 'Description4', label: 'Description 4' },
  { name: 'Category', label: 'Category' },
];
